import React from 'react';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import Builder from '../../../components/Builder';
import QueryBuilder from './QueryBuilder';

const Query = () => {
  return (
    <Builder queryType={QueryType.Expression}>
      <QueryBuilder />
    </Builder>
  );
};

export default Query;
